export function slugify(str: string): string {
    return str
      .replace(/[^\w\s]|_/g, "") // remove punctuation
      .toLowerCase()             // convert to lowercase
      .replace(/\s+/g, "-");     // replace spaces with dashes
  }
  